/**
 * @module error
 */

const state = {
  error: {},
  CommonErrorModalShow: false,
  AuthErrorModalShow: false,
  NetworkErrorModalShow: false,
  LoginTimeErrorModalShow: false,
}

const mutations = {
  setCommonErrorModalShow (state, payload) {
    if (payload) {
      state.error = payload
      state.CommonErrorModalShow = true
    } else {
      state.error = {}
      state.CommonErrorModalShow = false
    }
  },
  setAuthErrorModalShow (state, payload) {
    state.AuthErrorModalShow = payload
  },
  setNetworkErrorModalShow (state, payload) {
    state.NetworkErrorModalShow = payload
  },
  setLoginTimeErrorModalShow (state, payload) {
    state.LoginTimeErrorModalShow = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
